import Image from './Image'

export * from './Image'

export default Image
